/** Shared validation error messages for Object Panel (X, Y, W, H) */
export const VALIDATION_ERRORS = {
  PLEASE_ENTER_VALID_DATA: 'Please enter valid data',
  NEGATIVE_VALUE: "Can't be negative",
  INVALID_NUMBER: 'Invalid entry',
  UNRECOGNIZED_UNIT: 'Unrecognized unit',
  CANT_BE_BLANK: "Can't be blank",
  /** X/Y would place the object (any part of its rotated bounding box) outside the pasteboard's fixed work area. */
  OUT_OF_RANGE_POSITION: 'Value restored.',
} as const
